function simple(node, visitors, baseVisitor, state, override) {
  if (!baseVisitor) {
    baseVisitor = base;
  }
  (function c(node2, st, override2) {
    var type = override2 || node2.type, found = visitors[type];
    baseVisitor[type](node2, st, c);
    if (found) {
      found(node2, st);
    }
  })(node, state, override);
}
function ancestor(node, visitors, baseVisitor, state, override) {
  var ancestors = [];
  if (!baseVisitor) {
    baseVisitor = base;
  }
  (function c(node2, st, override2) {
    var type = override2 || node2.type, found = visitors[type];
    var isNew = node2 !== ancestors[ancestors.length - 1];
    if (isNew) {
      ancestors.push(node2);
    }
    baseVisitor[type](node2, st, c);
    if (found) {
      found(node2, st || ancestors, ancestors);
    }
    if (isNew) {
      ancestors.pop();
    }
  })(node, state, override);
}
function recursive(node, state, funcs, baseVisitor, override) {
  var visitor = funcs ? make(funcs, baseVisitor || void 0) : baseVisitor;
  (function c(node2, st, override2) {
    visitor[override2 || node2.type](node2, st, c);
  })(node, state, override);
}
function makeTest(test) {
  if (typeof test === "string") {
    return function(type) {
      return type === test;
    };
  } else if (!test) {
    return function() {
      return true;
    };
  } else {
    return test;
  }
}
var Found = function Found2(node, state) {
  this.node = node;
  this.state = state;
};
function full(node, callback, baseVisitor, state, override) {
  if (!baseVisitor) {
    baseVisitor = base;
  }
  (function c(node2, st, override2) {
    var type = override2 || node2.type;
    baseVisitor[type](node2, st, c);
    if (!override2) {
      callback(node2, st, type);
    }
  })(node, state, override);
}
function fullAncestor(node, callback, baseVisitor, state) {
  if (!baseVisitor) {
    baseVisitor = base;
  }
  var ancestors = [];
  (function c(node2, st, override) {
    var type = override || node2.type;
    var isNew = node2 !== ancestors[ancestors.length - 1];
    if (isNew) {
      ancestors.push(node2);
    }
    baseVisitor[type](node2, st, c);
    if (!override) {
      callback(node2, st || ancestors, ancestors, type);
    }
    if (isNew) {
      ancestors.pop();
    }
  })(node, state);
}
function findNodeAt(node, start, end, test, baseVisitor, state) {
  if (!baseVisitor) {
    baseVisitor = base;
  }
  test = makeTest(test);
  try {
    (function c(node2, st, override) {
      var type = override || node2.type;
      if ((start == null || node2.start <= start) && (end == null || node2.end >= end)) {
        baseVisitor[type](node2, st, c);
      }
      if ((start == null || node2.start === start) && (end == null || node2.end === end) && test(type, node2)) {
        throw new Found(node2, st);
      }
    })(node, state);
  } catch (e) {
    if (e instanceof Found) {
      return e;
    }
    throw e;
  }
}
function findNodeAround(node, pos, test, baseVisitor, state) {
  test = makeTest(test);
  if (!baseVisitor) {
    baseVisitor = base;
  }
  try {
    (function c(node2, st, override) {
      var type = override || node2.type;
      if (node2.start > pos || node2.end < pos) {
        return;
      }
      baseVisitor[type](node2, st, c);
      if (test(type, node2)) {
        throw new Found(node2, st);
      }
    })(node, state);
  } catch (e) {
    if (e instanceof Found) {
      return e;
    }
    throw e;
  }
}
function findNodeAfter(node, pos, test, baseVisitor, state) {
  test = makeTest(test);
  if (!baseVisitor) {
    baseVisitor = base;
  }
  try {
    (function c(node2, st, override) {
      if (node2.end < pos) {
        return;
      }
      var type = override || node2.type;
      if (node2.start >= pos && test(type, node2)) {
        throw new Found(node2, st);
      }
      baseVisitor[type](node2, st, c);
    })(node, state);
  } catch (e) {
    if (e instanceof Found) {
      return e;
    }
    throw e;
  }
}
function findNodeBefore(node, pos, test, baseVisitor, state) {
  test = makeTest(test);
  if (!baseVisitor) {
    baseVisitor = base;
  }
  var max;
  (function c(node2, st, override) {
    if (node2.start > pos) {
      return;
    }
    var type = override || node2.type;
    if (node2.end <= pos && (!max || max.node.end < node2.end) && test(type, node2)) {
      max = new Found(node2, st);
    }
    baseVisitor[type](node2, st, c);
  })(node, state);
  return max;
}
var create = Object.create || function(proto) {
  function Ctor() {
  }
  Ctor.prototype = proto;
  return new Ctor();
};
function make(funcs, baseVisitor) {
  var visitor = create(baseVisitor || base);
  for (var type in funcs) {
    visitor[type] = funcs[type];
  }
  return visitor;
}
function skipThrough(node, st, c) {
  c(node, st);
}
function ignore(_node, _st, _c) {
}
var base = {};
base.Program = base.BlockStatement = function(node, st, c) {
  for (var i = 0, list = node.body; i < list.length; i += 1) {
    var stmt = list[i];
    c(stmt, st, "Statement");
  }
};
base.Statement = skipThrough;
base.EmptyStatement = ignore;
base.ExpressionStatement = base.ParenthesizedExpression = base.ChainExpression = function(node, st, c) {
  return c(node.expression, st, "Expression");
};
base.IfStatement = function(node, st, c) {
  c(node.test, st, "Expression");
  c(node.consequent, st, "Statement");
  if (node.alternate) {
    c(node.alternate, st, "Statement");
  }
};
base.LabeledStatement = function(node, st, c) {
  return c(node.body, st, "Statement");
};
base.BreakStatement = base.ContinueStatement = ignore;
base.WithStatement = function(node, st, c) {
  c(node.object, st, "Expression");
  c(node.body, st, "Statement");
};
base.SwitchStatement = function(node, st, c) {
  c(node.discriminant, st, "Expression");
  for (var i$1 = 0, list$1 = node.cases; i$1 < list$1.length; i$1 += 1) {
    var cs = list$1[i$1];
    if (cs.test) {
      c(cs.test, st, "Expression");
    }
    for (var i = 0, list = cs.consequent; i < list.length; i += 1) {
      var cons = list[i];
      c(cons, st, "Statement");
    }
  }
};
base.SwitchCase = function(node, st, c) {
  if (node.test) {
    c(node.test, st, "Expression");
  }
  for (var i = 0, list = node.consequent; i < list.length; i += 1) {
    var cons = list[i];
    c(cons, st, "Statement");
  }
};
base.ReturnStatement = base.YieldExpression = base.AwaitExpression = function(node, st, c) {
  if (node.argument) {
    c(node.argument, st, "Expression");
  }
};
base.ThrowStatement = base.SpreadElement = function(node, st, c) {
  return c(node.argument, st, "Expression");
};
base.TryStatement = function(node, st, c) {
  c(node.block, st, "Statement");
  if (node.handler) {
    c(node.handler, st);
  }
  if (node.finalizer) {
    c(node.finalizer, st, "Statement");
  }
};
base.CatchClause = function(node, st, c) {
  if (node.param) {
    c(node.param, st, "Pattern");
  }
  c(node.body, st, "Statement");
};
base.WhileStatement = base.DoWhileStatement = function(node, st, c) {
  c(node.test, st, "Expression");
  c(node.body, st, "Statement");
};
base.ForStatement = function(node, st, c) {
  if (node.init) {
    c(node.init, st, "ForInit");
  }
  if (node.test) {
    c(node.test, st, "Expression");
  }
  if (node.update) {
    c(node.update, st, "Expression");
  }
  c(node.body, st, "Statement");
};
base.ForInStatement = base.ForOfStatement = function(node, st, c) {
  c(node.left, st, "ForInit");
  c(node.right, st, "Expression");
  c(node.body, st, "Statement");
};
base.ForInit = function(node, st, c) {
  if (node.type === "VariableDeclaration") {
    c(node, st);
  } else {
    c(node, st, "Expression");
  }
};
base.DebuggerStatement = ignore;
base.FunctionDeclaration = function(node, st, c) {
  return c(node, st, "Function");
};
base.VariableDeclaration = function(node, st, c) {
  for (var i = 0, list = node.declarations; i < list.length; i += 1) {
    var decl = list[i];
    c(decl, st);
  }
};
base.VariableDeclarator = function(node, st, c) {
  c(node.id, st, "Pattern");
  if (node.init) {
    c(node.init, st, "Expression");
  }
};
base.Function = function(node, st, c) {
  if (node.id) {
    c(node.id, st, "Pattern");
  }
  for (var i = 0, list = node.params; i < list.length; i += 1) {
    var param = list[i];
    c(param, st, "Pattern");
  }
  c(node.body, st, node.expression ? "Expression" : "Statement");
};
base.Pattern = function(node, st, c) {
  if (node.type === "Identifier") {
    c(node, st, "VariablePattern");
  } else if (node.type === "MemberExpression") {
    c(node, st, "MemberPattern");
  } else {
    c(node, st);
  }
};
base.VariablePattern = ignore;
base.MemberPattern = skipThrough;
base.RestElement = function(node, st, c) {
  return c(node.argument, st, "Pattern");
};
base.ArrayPattern = function(node, st, c) {
  for (var i = 0, list = node.elements; i < list.length; i += 1) {
    var elt = list[i];
    if (elt) {
      c(elt, st, "Pattern");
    }
  }
};
base.ObjectPattern = function(node, st, c) {
  for (var i = 0, list = node.properties; i < list.length; i += 1) {
    var prop = list[i];
    if (prop.type === "Property") {
      if (prop.computed) {
        c(prop.key, st, "Expression");
      }
      c(prop.value, st, "Pattern");
    } else if (prop.type === "RestElement") {
      c(prop.argument, st, "Pattern");
    }
  }
};
base.Expression = skipThrough;
base.ThisExpression = base.Super = base.MetaProperty = ignore;
base.ArrayExpression = function(node, st, c) {
  for (var i = 0, list = node.elements; i < list.length; i += 1) {
    var elt = list[i];
    if (elt) {
      c(elt, st, "Expression");
    }
  }
};
base.ObjectExpression = function(node, st, c) {
  for (var i = 0, list = node.properties; i < list.length; i += 1) {
    var prop = list[i];
    c(prop, st);
  }
};
base.FunctionExpression = base.ArrowFunctionExpression = base.FunctionDeclaration;
base.SequenceExpression = function(node, st, c) {
  for (var i = 0, list = node.expressions; i < list.length; i += 1) {
    var expr = list[i];
    c(expr, st, "Expression");
  }
};
base.TemplateLiteral = function(node, st, c) {
  for (var i = 0, list = node.quasis; i < list.length; i += 1) {
    var quasi = list[i];
    c(quasi, st);
  }
  for (var i$1 = 0, list$1 = node.expressions; i$1 < list$1.length; i$1 += 1) {
    var expr = list$1[i$1];
    c(expr, st, "Expression");
  }
};
base.TemplateElement = ignore;
base.UnaryExpression = base.UpdateExpression = function(node, st, c) {
  c(node.argument, st, "Expression");
};
base.BinaryExpression = base.LogicalExpression = function(node, st, c) {
  c(node.left, st, "Expression");
  c(node.right, st, "Expression");
};
base.AssignmentExpression = base.AssignmentPattern = function(node, st, c) {
  c(node.left, st, "Pattern");
  c(node.right, st, "Expression");
};
base.ConditionalExpression = function(node, st, c) {
  c(node.test, st, "Expression");
  c(node.consequent, st, "Expression");
  c(node.alternate, st, "Expression");
};
base.NewExpression = base.CallExpression = function(node, st, c) {
  c(node.callee, st, "Expression");
  if (node.arguments) {
    for (var i = 0, list = node.arguments; i < list.length; i += 1) {
      var arg = list[i];
      c(arg, st, "Expression");
    }
  }
};
base.MemberExpression = function(node, st, c) {
  c(node.object, st, "Expression");
  if (node.computed) {
    c(node.property, st, "Expression");
  }
};
base.ExportNamedDeclaration = base.ExportDefaultDeclaration = function(node, st, c) {
  if (node.declaration) {
    c(node.declaration, st, node.type === "ExportNamedDeclaration" || node.declaration.id ? "Statement" : "Expression");
  }
  if (node.source) {
    c(node.source, st, "Expression");
  }
};
base.ExportAllDeclaration = function(node, st, c) {
  if (node.exported) {
    c(node.exported, st);
  }
  c(node.source, st, "Expression");
};
base.ImportDeclaration = function(node, st, c) {
  for (var i = 0, list = node.specifiers; i < list.length; i += 1) {
    var spec = list[i];
    c(spec, st);
  }
  c(node.source, st, "Expression");
};
base.ImportExpression = function(node, st, c) {
  c(node.source, st, "Expression");
};
base.ImportSpecifier = base.ImportDefaultSpecifier = base.ImportNamespaceSpecifier = base.Identifier = base.Literal = ignore;
base.TaggedTemplateExpression = function(node, st, c) {
  c(node.tag, st, "Expression");
  c(node.quasi, st, "Expression");
};
base.ClassDeclaration = base.ClassExpression = function(node, st, c) {
  return c(node, st, "Class");
};
base.Class = function(node, st, c) {
  if (node.id) {
    c(node.id, st, "Pattern");
  }
  if (node.superClass) {
    c(node.superClass, st, "Expression");
  }
  c(node.body, st);
};
base.ClassBody = function(node, st, c) {
  for (var i = 0, list = node.body; i < list.length; i += 1) {
    var elt = list[i];
    c(elt, st);
  }
};
base.MethodDefinition = base.Property = function(node, st, c) {
  if (node.computed) {
    c(node.key, st, "Expression");
  }
  c(node.value, st, "Expression");
};
export {ancestor, base, findNodeAfter, findNodeAround, findNodeAt, findNodeBefore, full, fullAncestor, make, recursive, simple};
//# sourceMappingURL=data:application/json;base64,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
